import React from 'react';
import GraphPerson from './GraphPerson';
import GraphMoney from './GraphMoney';
import GraphHome from './GraphHome';

import numeral from 'numeral';

// load a language
numeral.language('es', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal : function (number) {
        return number === 1 ? 'er' : 'ème';
    },
    currency: {
        symbol: '€'
    }
});

numeral.language('es');
export default class Graph extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    console.log(this.props.item);

    let muertes = numeral(this.props.item.muertos).format('0,0');
    let magnitud = this.props.item.magnitud + 'º';
    let viviendas = ((this.props.item.viviendas !== false) ? (<div className="columns small-6 casas">
      <GraphHome
        items={this.props.items}
        item={this.props.item}/>
    </div>) : false);

    let danos = ((this.props.item.danos !== false) ? (
      <div className="columns small-6 dinero">
        <GraphMoney
          items={this.props.items}
          item={this.props.item}/>
      </div>
    ) : false);

    return (
      <div className="earthquake-info">
        <div className="columns small-6 magnitud">
          <h1>{magnitud}</h1>
          <h3>fue la magnitud del sismo que azotó la zona</h3>
        </div>
        <GraphPerson
          item={this.props.item}
          items={this.props.items} />
        {viviendas}
        {danos}
        <span></span>
      </div>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./client/Graph.js
 **/